import React from "react";
import { Link } from "react-router-dom";
import { PageHeader, EmptyState } from "../components/common";
import { Button } from "../components/ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";

/**
 * A shared placeholder for modules that are scaffolded in Phase 1 but
 * will be fully built in Phase 3. Each variant explains what's arriving,
 * what to use today, and links to the closest existing workflow.
 */
export default function ComingSoonPage({ variant }) {
  const map = {
    obligations: {
      eyebrow: "Les Devoirs",
      title: "Obligations",
      description:
        "Marianne will automatically extract payment dates, renewals, termination windows and reporting duties from your executed agreements — then remind you before they matter.",
      note:
        "For now, you can track dates manually in Deadlines. Automatic extraction arrives in Phase 3, alongside the full Agreement lifecycle upgrade.",
      today: { label: "Use Deadlines for now", to: "/app/tasks" },
    },
    disputes: {
      eyebrow: "Les Différends",
      title: "Disputes",
      description:
        "A structured space for pre-litigation disputes — organise the story, gather evidence, draft demand letters, and choose between negotiation, mediation, arbitration and court before it escalates.",
      note:
        "Draft a demand letter or legal notice from the Templates library today. The full Disputes workflow (Claim Explorer + resolution pathways) ships in Phase 2.",
      today: { label: "Open Templates", to: "/app/templates" },
    },
    documents: {
      eyebrow: "Le Dossier",
      title: "Documents",
      description:
        "One searchable place for every document Marianne knows about — drafts, executed agreements, evidence, filings, notices.",
      note:
        "Drafts and Agreements each have their own view for now. A unified Documents index with per-document Q&A (Document Intelligence) arrives in Phase 3.",
      today: { label: "Browse Drafts", to: "/app/drafts" },
    },
    contacts: {
      eyebrow: "Les Contreparties",
      title: "Contacts",
      description:
        "Your counterparties, opposing parties, witnesses and lawyers in one address book — with the matters, agreements and cases they touch.",
      note:
        "Parties currently live inside each Case. A cross-matter contact directory arrives in Phase 3.",
      today: { label: "Open Matters", to: "/app/matters" },
    },
  };
  const v = map[variant] || map.obligations;

  return (
    <div data-testid={`coming-soon-${variant}`}>
      <PageHeader eyebrow={v.eyebrow} title={v.title} description={v.description} />
      <div className="border border-[#E8E3F0] bg-white p-8 max-w-3xl">
        <div className="label-eyebrow text-[#C5A059] mb-3">Arriving next</div>
        <p className="text-[#2A0F5A]/80 leading-relaxed mb-6">{v.note}</p>
        <Link to={v.today.to}>
          <Button className="rounded-none bg-[#2A0F5A] hover:bg-[#3D1F85] text-[#FAFAF8]" data-testid={`coming-soon-${variant}-cta`}>
            {v.today.label} <ArrowRight size={14} className="ml-1.5" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
